// extracted by mini-css-extract-plugin
export default {"wrapper":"MetricItem_wrapper__I6CLt","label":"MetricItem_label__2rNAR","amount":"MetricItem_amount__OcdKy","loader":"MetricItem_loader__O38W3"};